define([],
    function() {

        return {
            trackEvent: function(eventName, metadata) {
                if (window.Intercom) {
                    Intercom('trackEvent', eventName, metadata);
                }
            }
        };

    }
);
